module.exports = __webpack_public_path__ + "img/storehouse.aa531402.png";